import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const RequireAuth = ({ allowedGroups }) => {
    //OK-tracefabrics

    //const RequireAuth = ({ allowedPermissions }) => {
    const { auth } = useAuth();
    const location = useLocation();

    //console.log("RequireAuth.js > RequireAuth > auth :", JSON.stringify(auth));

    return (
        auth?.group_name && allowedGroups?.includes(auth.group_name)
            //hasPermission
            ? <Outlet />
            : auth?.user
                ? <Navigate to="/unauthorized" state={{ from: location }} replace />
                : <Navigate to="/login" state={{ from: location }} replace />
    );
}

export default RequireAuth


